import { PageLayout, Text } from "components";
import { CaretLeftIcon, NutOutlineIcon } from "components/icons";
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { E_Route } from "utils/constants";
import { SETTING_MENU } from "../menu";
import {
  SettingBackStyle,
  SettingHeaderTitle,
  SettingMenuHeader2Style,
  SettingMenuHeaderStyle,
  SettingMenuStyle,
} from "../styles";

export const SettingsBaseScreen: React.FC = () => {
  const location = useLocation();
  const navigation = useNavigate();

  const isHome = location.pathname === E_Route.Settings;
  const getPageName = (path: string) => {
    let name = "";
    let Icon;
    SETTING_MENU.forEach((menu: any) => {
      const page = menu.items.find((subItem: any) => subItem.link === path);
      if (page) {
        name = page.label;
        Icon = page.Icon;
      }
    });

    return {
      name,
      Icon,
    };
  };

  const goBack = () => {
    navigation(-1);
  };
  const { name, Icon } = getPageName(location.pathname);
  const PageIcon = Icon ? Icon : NutOutlineIcon;
  return (
    <PageLayout title="Settings | Multiplayer">
      <div className={SettingMenuStyle}>
        {isHome ? (
          <div className={SettingMenuHeaderStyle}>
            <NutOutlineIcon
              fill="primary"
              style={{ width: "24px", height: "24px", marginRight: "8px" }}
            />
            <Text.H3>Settings</Text.H3>
          </div>
        ) : (
          <div className={SettingMenuHeader2Style}>
            <div className={SettingBackStyle} onClick={goBack}>
              <CaretLeftIcon
                fill="darkGrey"
                style={{
                  width: "24px",
                  height: "24px",
                  marginRight: "8px",
                }}
              />
              <Text.BodyXS color="darkGrey">Back</Text.BodyXS>
            </div>
            <div className={SettingHeaderTitle}>
              <PageIcon
                fill="primary"
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
              <Text.H3>{name || "Settings"}</Text.H3>
            </div>
          </div>
        )}
        <Outlet />
      </div>
    </PageLayout>
  );
};
